export default __webpack_public_path__ + "static/adam-e57871ca46617f425f2ae895793246b2.png";